import axios from 'lib/axios';
import {
  removeAuthCookie,
  removeDivFilterInStorage,
  removeDivisionInStorage,
  removeNavigationInStorage,
  removeUserInStorage,
  setOTPTokenCookie,
  getOTPTokenCookie,
  removeAccessTokenCookie,
  removeRefreshTokenCookie
} from 'lib/Storage';

const login = async (username, password) => {
  const { data } = await axios.post('/admin/login', username, password);
  return data;
};

const requestOTP = async (phoneNumber) =>{
  const {data}  = await axios.post("/customer/requestOtp",{msisdn:phoneNumber})
  console.log("data in requestotp:",data)
  if(data.status === "OK"){
    setOTPTokenCookie(data.otpToken)
  }
  return data;
}


const submitOTP = async (code) =>{
  let otpToken = getOTPTokenCookie()
  const {data}  = await axios.post("/customer/submitOtp",{otp:code,otpToken})
  return data;
}

const signup = async (signupData) =>{
  console.log("api:",signupData)
  const {data}  = await axios.post("/customer/signup",signupData)
  return data;
}

const logout = () => {
  removeAuthCookie();
  removeDivFilterInStorage();
  removeDivisionInStorage();
  removeUserInStorage();
  removeNavigationInStorage();
  removeAccessTokenCookie();
  removeRefreshTokenCookie();
  // eslint-disable-next-line no-restricted-globals
  location.reload();
};

export { login, logout, requestOTP, submitOTP , signup };
